module.exports = __webpack_public_path__ + "media/images/soar/office-0256f540c68d4907e81122c9fed248c2.png";